import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createCategory } from "../../services/categories";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useCreateCategory = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createCategory,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                indicators.setIsProcessRunning(false);
                toast.success('Category created successfully')
                queryClient.invalidateQueries({ queryKey: ['categories'] });
            }
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            toast.error(error.response?.data?.message);
            indicators.setIsServiceError(error.response?.data?.message);
        }
    });
};

export default useCreateCategory;